import React from "react";

const StockAudit = () => {
  return <div>StockAudit</div>;
};

export default StockAudit;
